import axios from '../../localAxios';
import { moveWorkspaceQuizzesURL } from '../workspacesURLs';

interface MoveWorkspaceQuizzesParams {
  workspaceId: string;
  workspaceQuizIds: string[];
  parentFolderId?: string;
}

export async function moveWorkspaceQuizzes({
  workspaceId,
  workspaceQuizIds,
  parentFolderId = null,
}: MoveWorkspaceQuizzesParams) {
  if (workspaceQuizIds.length < 1) {
    return;
  }
  const url = await moveWorkspaceQuizzesURL(workspaceId);
  const response = await axios.put(url.href, {
    parent_id: parentFolderId,
    workspace_quiz_ids: workspaceQuizIds,
  });

  return response.data;
}
